import React, { useEffect } from 'react'
import Onboarding from '.'
import useAxios from 'hooks/useAxios'
import { Loader } from 'shared/components/Loader'
import { toast } from 'libs/toast'
import * as R from 'ramda'
import useWorkspace from 'hooks/useWorkspace'
import { setDefaultHeaders } from 'api'
import { Redirect } from 'react-router-dom'
import useUser from 'hooks/useUser'
import { getStartingPreferences, processLogoData } from './utils'

export default function OnboardingContainer() {
  const workspaceToken = useWorkspace()
  setDefaultHeaders(workspaceToken)
  const user = useUser()

  const {
    loading: loadingPreferences,
    data: preferences,
    error: errorLoadingPreferences,
  } = useAxios({
    url: `account/company/preferences/`,
  })

  const {
    loading: loadingPrefills,
    data: prefills,
    error: errorLoadingPrefills,
  } = useAxios({
    url: `account/onboarding-prefill/`,
  })

  const { fetch: saveStarterItems, loading: savingStarterItems } = useAxios({
    url: 'account/company/preferences',
    method: 'post',
    skip: true,
  })

  const { data: brands } = useAxios({
    url: 'brand/brands/',
  })

  const { fetch: saveBrandSettings } = useAxios({
    method: 'patch',
    skip: true,
  })

  const preloadImages = (preferences) => {
    const integration_types = [
      'bi_integration',
      'crm_integration',
      'helpdesk_integration',
      'message_integration',
      'other_integration',
    ]
    Object.keys(preferences).forEach((key) => {
      if (integration_types.includes(key)) {
        preferences[key].forEach((integration) => {
          if (integration.image) {
            const img = new Image()
            img.src = integration.image
          }
        })
      }
    })
  }

  useEffect(() => {
    if (preferences) {
      preloadImages(preferences)
    }
  }, [preferences])

  if (user && !user.selected_workspace.should_launch_onboarding) {
    return <Redirect to={`/${workspaceToken}/dashboards/home/`} />
  }

  const loadingPrefillData = loadingPrefills || (!prefills && !errorLoadingPrefills)
  const loadingPreferenceData = loadingPreferences || (!preferences && !errorLoadingPreferences)
  if (loadingPreferenceData || loadingPrefillData) {
    return <Loader />
  }

  if (errorLoadingPreferences) {
    toast.error('Error fetching company preferencess.')
  }

  if (errorLoadingPrefills) {
    console.error(
      `Error fetching prefill information: ${errorLoadingPrefills.response?.data?.message}`
    )
  }

  const defautlBrands = R.prop('results', brands) || []
  const companyId = R.path(['selected_workspace', 'id'], user)
  const companyName = R.path(['selected_workspace', 'name'], user)

  return (
    <Onboarding
      preferences={preferences}
      brandLogos={processLogoData(prefills)}
      brandColors={R.prop('colors', prefills)}
      startingPreferences={getStartingPreferences(prefills, preferences)}
      saveStarterItems={saveStarterItems}
      savingStarterItems={savingStarterItems}
      saveBrandSettings={saveBrandSettings}
      defautlBrand={defautlBrands[0]}
      companyId={companyId}
      companyName={companyName}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Onboarding/container.js